import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

// GET: List all credit notes
export const getCreditNotes = async () => {
  const res = await axiosInstance.get("creditnotes/get-credit-notes");
  return res.data;
};

// GET: Get credit note by ID
export const getCreditNote = async (id) => {
  const res = await axiosInstance.get(`creditnotes/get-credit-note/${id}`);
  return res.data;
};

// POST: Add new credit note
export const addCreditNote = async (creditNote) => {
  const res = await axiosInstance.post("creditnotes/add-credit-note", creditNote);
  return res.data;
};

// PUT: Update credit note by ID
export const updateCreditNote = async (id, creditNote) => {
  const res = await axiosInstance.put(`creditnotes/update-credit-note/${id}`, creditNote);
  return res.data;
};

// DELETE: Delete credit note by ID
export const deleteCreditNote = async (id) => {
  const res = await axiosInstance.delete(`creditnotes/delete-credit-note/${id}`);
  return res.data;
};

// POST: Send credit note to Peppol
export const sendCreditNoteToPeppol = async (creditNoteData) => {
  const response = await axiosInstance.post('Peppol/send-credit-note', creditNoteData);
  return response.data;
};

// GET: Search invoices by invoice number (minimum 3 characters)
export const searchInvoices = async (searchTerm) => {
  if (!searchTerm || searchTerm.length < 3) {
    return [];
  }
  const response = await axiosInstance.get(`Invoices/search`, {
    params: { searchTerm }
  });
  return response.data;
};

// GET: Get invoices sent to Peppol (for credit note creation)
export const getPeppolInvoices = async () => {
  const response = await axiosInstance.get('Invoices/get-invoices');
  const data = response.data;
  
  // Filter invoices that were sent to Peppol
  if (data.status === 'Success' && data.payload) {
    return data.payload.filter(invoice => invoice.IsSendOnPeppol === true);
  }
  
  return [];
};